import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';


@Component({
  selector: 'app-weather-legend',
  templateUrl: './weather-legend.component.html',
  styleUrls: ['./weather-legend.component.scss']
})
export class WeatherLegendComponent implements OnInit {

  constructor(private _matDialogRef: MatDialogRef<WeatherLegendComponent>) { }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close();
    });
  }

  close() {
    this._matDialogRef.close();
  }
}
